<template>
  <div>
    <div class="col-sm-12 col-xs-12 col-md-12">
      <hr />
    </div>
    <div class="col-sm-12 col-md-12 col-xs-12">
      <div class="virtual-tour-content">
        Learn about the features available within RAMS with a walk-through tutorial.
      </div>
      <button @click="openTour()" class="btn emergo-green-button tour-button">
        <img
          class="tour-icon"
          src="/static/images/icons/virtual_tour_white_icon.svg"
          alt="tour-icon"
        />
        <span class="start-tour">Start Tour</span>
      </button>
    </div>
  </div>
</template>

<script>
import EventBus from '../../utils/event-bus';

export default {
  data() {
    return {};
  },
  methods: {
    openTour() {
      this.$emit('closepopup');
      EventBus.$emit('displayTour');
    }
  }
};
</script>

<style lang="scss" scoped>
.tour-button {
  width: 185px;
  margin-top: 24px;
}
.tour-icon {
  padding-right: 15px;
  padding-bottom: 4px;
}
.start-tour {
  text-align: center;
  color: $deep-white;
  @include fontItems($font-18, 21px, $font-weight-medium);
}
.virtual-tour-content {
  font-style: normal;
  @include fontItems($font-18, 21px, $font-weight-small);
  color: $dark-black-alpha;
  width: 339px;
  margin-top: 1px;
  padding-left: 10px;
}
</style>
